import { FC } from 'react';
import Link from 'next/link';
import Image from 'next/image';

import Heading from '@/components/common/Heading';
// import Link from 'next/link';

import { sfFeatureType } from '@/types';

interface IFeaturesItemProps {
  sfIdText: string;
  sfBackground: string;
  sfIcon: string;
  sfTittle: string;
  sfText: string;
  sfFeature: sfFeatureType[];
  sfButtonText: string;
  sfLink: string;
  sfAriaLabel: string;
}

const FeaturesItem: FC<IFeaturesItemProps> = ({
  sfIdText,
  sfBackground,
  sfIcon,
  sfTittle,
  sfText,
  sfFeature,
  sfButtonText,
  sfLink,
  sfAriaLabel,
}) => {
  return (
    <div className="pb-[70px] bg-gradient-[180deg] from-[#ffffff] to-[#e9e9e930] rounded-b-[15px] shadow-[0px_6px_10px_-8px_#d5d5d5] ">
      <div className=" flex flex-col justify-center items-center  ">
        <div
          style={{ backgroundColor: sfBackground }}
          className="w-16 h-16 mb-20 rounded-full flex justify-center items-center"
        >
          <span className="text-xl text-white">{sfIdText}</span>
        </div>

        <Heading headingLevel="h3" className="mb-6 text-center">
          {sfTittle}
        </Heading>
        <p className=" custom-p w-[90%] md:max-w-[645px] lg:max-w-[652px] mb-16">
          {sfText}
        </p>
      </div>

      <div className="flex flex-col items-center  lg:flex-row lg:justify-evenly lg:items-start">
        <Image
          className=" w-[80%] md:w-[30%] lg:sticky  lg:top-[--h-header] duration-[--duration] group-hover:top-[-10px] mb-5 lg:mb-0"
          src={`/assets/icons/features/services/${sfIcon}`}
          width={100}
          height={100}
          alt={`${sfTittle}`}
        />
        <ul>
          {sfFeature.map(({ id, tittle, text, icon }) => (
            <li key={id} className={`mb-6`}>
              <Image
                className=" w-10 mx-auto lg:mx-0 mb-4 "
                src={`/assets/icons/services/${icon}`}
                width={100}
                height={100}
                alt={`${tittle}`}
              />
              <div className=" mb-16 max-w-[460px]">
                <Heading
                  headingLevel="h4"
                  className=" mb-4   text-center lg:text-left "
                >
                  {tittle}
                </Heading>
                <p className="custom-p ">{text}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
      <Link
        href={`/services/${sfLink}`}
        className=" mx-auto custom-button custom-button-hover  w-[170px]  cursor-pointer"
        aria-label={sfAriaLabel}
      >
        {sfButtonText}
      </Link>
    </div>
  );
};

export default FeaturesItem;
